import { useCallback as b, useState as h, useRef as H, useEffect as m, useMemo as P } from "react";
import { $ as y, a as x, b as C, c as M, d as S } from "./useLocalizedStringFormatter-BVBIfLvJ.mjs";
function D(a) {
  let { isDisabled: i, onFocus: s, onBlur: n, onFocusChange: t } = a;
  const f = b((o) => {
    if (o.target === o.currentTarget)
      return n && n(o), t && t(!1), !0;
  }, [
    n,
    t
  ]), c = y(f), r = b((o) => {
    const d = x(o.target);
    o.target === o.currentTarget && d.activeElement === o.target && (s && s(o), t && t(!0), c(o));
  }, [
    t,
    s,
    c
  ]);
  return {
    focusProps: {
      onFocus: !i && (s || t || n) ? r : void 0,
      onBlur: !i && (n || t) ? f : void 0
    }
  };
}
let $ = !1, E = 0;
function F() {
  $ = !0, setTimeout(() => {
    $ = !1;
  }, 50);
}
function T(a) {
  a.pointerType === "touch" && F();
}
function V() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", T) : document.addEventListener("touchend", F), E++, () => {
      E--, !(E > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", T) : document.removeEventListener("touchend", F));
    };
}
function B(a) {
  let { onHoverStart: i, onHoverChange: s, onHoverEnd: n, isDisabled: t } = a, [f, c] = h(!1), r = H({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  m(V, []);
  let { hoverProps: o, triggerHoverEnd: d } = P(() => {
    let p = (e, l) => {
      if (r.pointerType = l, t || l === "touch" || r.isHovered || !e.currentTarget.contains(e.target)) return;
      r.isHovered = !0;
      let g = e.currentTarget;
      r.target = g, i && i({
        type: "hoverstart",
        target: g,
        pointerType: l
      }), s && s(!0), c(!0);
    }, v = (e, l) => {
      if (r.pointerType = "", r.target = null, l === "touch" || !r.isHovered) return;
      r.isHovered = !1;
      let g = e.currentTarget;
      n && n({
        type: "hoverend",
        target: g,
        pointerType: l
      }), s && s(!1), c(!1);
    }, u = {};
    return typeof PointerEvent < "u" ? (u.onPointerEnter = (e) => {
      $ && e.pointerType === "mouse" || p(e, e.pointerType);
    }, u.onPointerLeave = (e) => {
      !t && e.currentTarget.contains(e.target) && v(e, e.pointerType);
    }) : (u.onTouchStart = () => {
      r.ignoreEmulatedMouseEvents = !0;
    }, u.onMouseEnter = (e) => {
      !r.ignoreEmulatedMouseEvents && !$ && p(e, "mouse"), r.ignoreEmulatedMouseEvents = !1;
    }, u.onMouseLeave = (e) => {
      !t && e.currentTarget.contains(e.target) && v(e, "mouse");
    }), {
      hoverProps: u,
      triggerHoverEnd: v
    };
  }, [
    i,
    s,
    n,
    t,
    r
  ]);
  return m(() => {
    t && d({
      currentTarget: r.target
    }, r.pointerType);
  }, [
    t
  ]), {
    hoverProps: o,
    isHovered: f
  };
}
function w(a = {}) {
  let { autoFocus: i = !1, isTextInput: s, within: n } = a, t = H({
    isFocused: !1,
    isFocusVisible: i || C()
  }), [f, c] = h(!1), [r, o] = h(() => t.current.isFocused && t.current.isFocusVisible), d = b(() => o(t.current.isFocused && t.current.isFocusVisible), []), p = b((e) => {
    t.current.isFocused = e, c(e), d();
  }, [
    d
  ]);
  M((e) => {
    t.current.isFocusVisible = e, d();
  }, [], {
    isTextInput: s
  });
  let { focusProps: v } = D({
    isDisabled: n,
    onFocusChange: p
  }), { focusWithinProps: u } = S({
    isDisabled: !n,
    onFocusWithinChange: p
  });
  return {
    isFocused: f,
    isFocusVisible: r,
    focusProps: n ? u : v
  };
}
export {
  B as $,
  w as a,
  D as b
};
